export const API_URL = 'http://10.50.1.89:5000'
